"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteAppLicenseArgsValidator = exports.deleteAppLicenseArgsSchema = exports.updateAppLicenseArgsValidator = exports.updateAppLicenseArgsSchema = exports.createAppLicenseArgsValidator = exports.createAppLicenseArgsSchema = exports.createAppLicenseFromArgs = exports.WorkspaceNonConsumableSchema = exports.MemberAutoRenewSubscriptionSchema = exports.LicenseTypes = exports.getNextLicenseRenewalDate = exports.daysInMonth = void 0;
var suretype_1 = require("suretype");
var common_1 = require("../common");
// ==========================
// utils
// ==========================
/**
 *
 * @param utcYear index starts from 1
 * @param utcMonth 1 - 12
 */
function daysInMonth(utcYear, utcMonth) {
    // NOTE utcMonth is actually 0-indexed, but day is 1-indexed
    // => we can use 0 as the day to get the last day of the previous utcMonth
    // copied from https://stackoverflow.com/a/1184359/7446235
    return new Date(Date.UTC(utcYear, utcMonth, 0)).getUTCDate();
}
exports.daysInMonth = daysInMonth;
/**
 *
 * @param licenseTimestamp: number
 * @param currTimestamp: timestamp of current Date
 *
 * @returns timestamp of the next renewal date
 *
 * Note:
 * Renewal date is the date of the month when the license is renewed.
 * It is the minimum of the license start date and the number of days in the current month.
 */
function getNextLicenseRenewalDate(licenseTimestamp, currTimestamp) {
    var currDate = new Date(currTimestamp);
    var currUtcMonth = currDate.getUTCMonth() + 1;
    var currUtcYear = currDate.getUTCFullYear();
    var licenseStartDate = new Date(licenseTimestamp);
    var nextRenewalDay = Math.min(licenseStartDate.getUTCDate(), daysInMonth(currUtcYear, currUtcMonth));
    licenseStartDate.setUTCDate(nextRenewalDay);
    // if the license renewal date of curr month is in the past, then we need to use renewal date of month
    if (licenseStartDate.getTime() < currTimestamp) {
        var nextMonth = currUtcMonth === 12 ? 1 : currUtcMonth + 1;
        var yearOfNextMonth = currUtcMonth === 12 ? licenseStartDate.getUTCFullYear() + 1 : licenseStartDate.getUTCFullYear();
        nextRenewalDay = Math.min(licenseStartDate.getUTCDate(), daysInMonth(yearOfNextMonth, nextMonth));
        licenseStartDate.setUTCDate(nextRenewalDay);
        licenseStartDate.setUTCMonth(nextMonth - 1);
        licenseStartDate.setUTCFullYear(yearOfNextMonth);
    }
    return licenseStartDate.getTime();
}
exports.getNextLicenseRenewalDate = getNextLicenseRenewalDate;
// export function getNextLicenseRenewalDate(licenseTimestamp: number, currTimestamp: number) {
//     const currDate = new Date(currTimestamp)
//     return getLicenseRenewalDate()
// }
// ==========================
// interfaces
// ==========================
var LicenseTypes;
(function (LicenseTypes) {
    LicenseTypes[LicenseTypes["MemberAutoRenewSubscription"] = 0] = "MemberAutoRenewSubscription";
})(LicenseTypes = exports.LicenseTypes || (exports.LicenseTypes = {}));
exports.MemberAutoRenewSubscriptionSchema = suretype_1.v.object({
    type: suretype_1.v.number().const(LicenseTypes.MemberAutoRenewSubscription).required(),
    price: suretype_1.v.number().gte(0).lte(1000).required(),
    // the higher the level the more features
    level: suretype_1.v.number().gte(0).lte(1000).required(),
});
exports.WorkspaceNonConsumableSchema = suretype_1.v.object({
    type: suretype_1.v.number().const(1).required(),
    price: suretype_1.v.number().gte(0).lte(1000).required(),
    maxQuantity: suretype_1.v.number().gte(0).lte(1000).required(),
});
function createAppLicenseFromArgs(_a) {
    var license = _a.license, title = _a.title, subTitle = _a.subTitle, description = _a.description;
    return {
        details: {
            title: title,
            subTitle: subTitle,
            description: description,
            license: license
        },
        // sort
        createdAt: Date.now(),
    };
}
exports.createAppLicenseFromArgs = createAppLicenseFromArgs;
exports.createAppLicenseArgsSchema = suretype_1.v.object({
    appId: common_1.idSchema.required(),
    licenseId: common_1.idSchema.required(),
    license: suretype_1.v.anyOf([exports.MemberAutoRenewSubscriptionSchema, exports.WorkspaceNonConsumableSchema]).required(),
    title: suretype_1.v.string().maxLength(30).required(),
    subTitle: suretype_1.v.string().maxLength(30).required(),
    description: suretype_1.v.string().maxLength(1000).required(),
});
exports.createAppLicenseArgsValidator = (0, suretype_1.compile)(exports.createAppLicenseArgsSchema);
exports.updateAppLicenseArgsSchema = suretype_1.v.object({
    appId: common_1.idSchema.required(),
    licenseId: common_1.idSchema.required(),
    license: suretype_1.v.anyOf([exports.MemberAutoRenewSubscriptionSchema, exports.WorkspaceNonConsumableSchema]).required(),
    title: suretype_1.v.string().maxLength(30).required(),
    subTitle: suretype_1.v.string().maxLength(30).required(),
    description: suretype_1.v.string().maxLength(1000).required(),
});
exports.updateAppLicenseArgsValidator = (0, suretype_1.compile)(exports.updateAppLicenseArgsSchema);
exports.deleteAppLicenseArgsSchema = suretype_1.v.object({
    appId: common_1.idSchema.required(),
    licenseId: common_1.idSchema.required()
});
exports.deleteAppLicenseArgsValidator = (0, suretype_1.compile)(exports.deleteAppLicenseArgsSchema);
